import { useSearchParams } from 'react-router-dom';

/** Сохраняет query виджета (`org_slug`, `branch_id`, key, …) при навигации. */
export function useQuerySuffix(): string {
  const [searchParams] = useSearchParams();
  const qs = searchParams.toString();
  return qs ? `?${qs}` : '';
}
